export default __webpack_public_path__ + "static/media/WebForensics_WelcomeScreen_Screenshots_Tip1.f467e57e.jpg";